import { NeoState } from '~/store/Reducers.interface';

export const selectProviderCategoryList = (state: NeoState) => state.provider?.categoryList;
